import { Typography } from '@mui/material';
import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error, errorInfo });
    console.error("ErrorBoundary caught an error", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{width: "100vw", height: "100vh", alignItems: "center", justifyContent: "center", display: "flex", flexDirection: "column"}}>
          <Typography sx={{fontSize: "20px", color: "secondary.main"}}>Something went wrong.</Typography>
          {this.state.error && (
            <Typography sx={{mt: 2, color: "error.main", fontSize: "14px"}}>
              {this.state.error.toString()}
            </Typography>
          )}
          {this.state.errorInfo && (
            <pre style={{ color: "#888", fontSize: "12px", marginTop: 8, maxWidth: 600, overflow: "auto" }}>
              {this.state.errorInfo.componentStack}
            </pre>
          )}
        </div>
      );
    }

    return this.props.children; 
  }
}

export default ErrorBoundary;